import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { history } from 'store/Store';
import { IAssembleiasAssociadoReducer } from 'store/modules/AssembleiasAssociadoReducer';
import { AssembleiaAssociadoRoutePath } from 'library/Routes';
import { AssembleiaIcon } from 'components/Icons';
import { Submenu } from './components';

interface Props {
  assembleias?: IAssembleiasAssociadoReducer;
  loader: Function;
  closeMenu: Function;
  needLoad: boolean;
}

export default function ({ assembleias, loader, closeMenu, needLoad }: Props) {
  const { t } = useTranslation();
  const [currentPath, setCurrentPath] = useState<string>(
    window.location.pathname
  );
  const onChangedLocation = () => setCurrentPath(window.location.pathname);
  const assembleiaPathname = AssembleiaAssociadoRoutePath.replace(':id/', '');

  useEffect(() => {
    const urlChangeUnlisten = history.listen(onChangedLocation);
    return () => urlChangeUnlisten();
  }, []);

  useEffect(() => {
    if (needLoad) {
      loader();
    }
  }, [loader, needLoad]);

  return (
    <Submenu
      name={t('LeftMenu.events')}
      icon={<AssembleiaIcon />}
      isLoading={assembleias?.loadingAll}
      items={assembleias?.all.map(event => ({
        path: AssembleiaAssociadoRoutePath.replace(':id', `${event.id}`),
        icon: <AssembleiaIcon />,
        text: event.nome,
        closeMenu,
      }))}
      isCurrent={currentPath.startsWith(assembleiaPathname)}
      isAssociado
    />
  );
}
